<template>
  <div class="layout userinfo">
    <div class="column" :style="addBackgroundImage()">
      <h1 key="question" v-html="$t(config.question, 'options.question')"></h1>
      <div class="small-print"></div>
    </div>
    <div class="column">
      <LeadForm
        :fields="signup.form.fields"
        :translation-contexts="translationContexts"
        @signup="save"
        :show-copy="false"
        :buttonText="config.buttonText || signup.buttonText"
        :editable="false"
        :config="formConfig"
      ></LeadForm>
    </div>
  </div>
</template>

<script>
import LeadForm from "./LeadForm";
import chroma from "chroma-js";
import TranslationMixin from "../lib/TranslationMixin";
export default {
  name: "UserInfo",
  mixins: [TranslationMixin],
  props: ["config"],
  components: {
    LeadForm
  },
  inject: ["theme"],
  data: function() {
    return {
      first_name: "",
      last_name: "",
      company: "",
      email: "",
      tel_no: "",
      errors: [],
      optin: false,
      complete: false,
      buttonStyles: {}
    };
  },
  computed: {
    translationContexts() {
      return {
        fields: "signup.form.fields",
        errors: "errors",
        signup: "signup"
      };
    },
    formConfig: function() {
      return {
        title: this.signup.form.title,
        enabledFields: this.signup.form.enabledFields,
        privacyStatement: this.signup.form.privacyStatement
      };
    },
    signup: function() {
      return this.$store.state.config.signup;
    },
    buttonStyle: function() {
      return {
        color: this.theme.accent.color,
        backgroundColor: this.theme.accent.backgroundColor
      };
    }
  },
  created() {
    this.getData();

    this.baseButtonStyles = this.theme.accent;
    let hoverColor = chroma(this.theme.accent.color)
      .darken()
      .hex();
    let hoverBackgroundColor = chroma(this.theme.accent.backgroundColor)
      .darken()
      .hex();
    let hoverStyle = {
      color: hoverColor,
      backgroundColor: hoverBackgroundColor
    };
    this.hoverButtonStyles = hoverStyle;
    this.buttonStyles = Object.assign({}, this.baseButtonStyles);
  },
  mounted() {
    let links = document.querySelectorAll("a");
    for (let link of links) {
      if (!link.href) {
        break;
      }
      if (link.host !== location.host) {
        link.setAttribute("target", "_blank");
      }
    }
  },
  methods: {
    async getData() {
      await this.$store.dispatch("start");
    },
    addBackgroundImage() {
      if (
        typeof this.config.background !== "undefined" &&
        this.config.background
      ) {
        return Object.assign(
          {},
          { backgroundImage: "url(" + this.config.background + ")" }
        );
      } else {
        return {};
      }
    },
    addHover(event) {
      this.buttonStyles = Object.assign({}, this.hoverButtonStyles);
    },
    removeHover(event) {
      this.buttonStyles = Object.assign({}, this.baseButtonStyles);
    },
    errorClass(fieldName, extraClasses) {
      let classes = ["field"];
      if (typeof extraClasses !== "undefined") {
        classes.push(extraClasses);
      }
      classes.push(this.errors.includes(fieldName) ? "invalid" : "valid");
      return classes.join(" ");
    },
    save(form) {
      let userInfo = form.lead;
      let extraInfo = form.extra;
      if (Object.keys(extraInfo).length > 0) {
        this.saveExtraInfo(extraInfo).then((resp) => {
          this.saveUserInfo(userInfo).then((resp) => {
            this.$gtag.event("signup", {
              event_category: "userinfo",
              event_label: "userPromoted",
              value: 1
            });
            this.$emit("answer");
            this.$store.commit("advance");
          });
        });
      } else {
        this.saveUserInfo(userInfo).then((resp) => {
          this.$gtag.event("signup", {
            event_category: "userinfo",
            event_label: "userPromoted",
            value: 1
          });
          this.$emit("answer");
          this.$store.commit("advance");
        });
      }
    },
    saveExtraInfo(extraInfo) {
      return this.$store.dispatch("save", {
        key: "_userdata",
        answer: { value: extraInfo }
      });
    },
    saveUserInfo(userInfo) {
      return this.$store.dispatch("promoteUser", {
        key: this.config.key,
        answer: { value: userInfo }
      });
    }
  }
};
</script>

<style lang="scss">
@import "../scss/base";
@import "../scss/components/survey";
.field.invalid {
  input {
    border-left: 10px solid $error-red;
  }
}
a.next {
  @include button;
  text-transform: uppercase;
  display: block;
  text-align: center;
  padding: 0.75em;
  transition: 0.3s all;
}
.layout {
  min-height: 100vh;
  @include mq($bp-8, landscape) {
    @include two-column-layout;
  }
  .column {
    padding: 5% 8%;
  }
}
@media screen and (min-width: 769px) and (orientation: landscape) {
  .layout {
    .column {
      padding: 5%;
    }
  }
}
</style>
